import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import Hero from './Hero';
import TrustLogos from './TrustLogos';
import CoreServices from './CoreServices';
import GeoExplanation from './GeoExplanation';
import EducationalContent from './EducationalContent';
import NycImportance from './NycImportance';
import Testimonials from './Testimonials';
import CtaSection from './CtaSection';

const Home = () => {
  useSEO({
    // Length: 54 characters
    title: 'NYC SEO Agency | #1 SEO & AI Search Optimization NYC',
    description: 'Dominate NYC search with the premier SEO agency. Expert Technical SEO, Local Search, and GEO strategies to rank in Google, ChatGPT, and Gemini.',
    keywords: 'NYC SEO, New York City SEO Services, Website Ranking, Local SEO, SEO Agency NYC, AI Search Optimization, GEO, Google Ranking'
  });

  return (
    <div className="w-full">
      <Hero />
      <TrustLogos />
      <GeoExplanation />
      <CoreServices />
      <NycImportance />
      <EducationalContent />
      <Testimonials />
      <CtaSection />
    </div>
  );
};

export default Home;